import React, { useEffect, useState } from 'react'
import { Grid, Typography, Button, Paper, Divider, Box, makeStyles } from '@material-ui/core'
import * as actions from '../actions';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
  sectionHeader: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),

  },
  label: {
    color: '#717171',
    fontSize: '0.9rem',
    marginBottom: '4px',
    display: 'block',
  },
  value: {
    fontWeight: 500,
    fontSize: '1rem',
    color: '#000',
  },
  cardContainer: {
    padding: theme.spacing(2),
    height: '100%',
    boxShadow: 'none',
    borderRadius: '4px',
  },
  monthTag: {
    background: '#f5f5f5',
    padding: '4px 12px',
    borderRadius: '4px',
    display: 'inline-block',
    margin: '2px 4px',
    fontSize: '0.85rem',
  },
  tempGroup: {
    borderRadius: '4px',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: '#fff',
  }
}));

export default function ViewHeatpumpModel() {
  const classes = useStyles();
  const { modelId } = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const { isFetchingSingleModel = false } = useSelector(state => state.heatPumpDevicesModels)

  const [modelData, setModelData] = useState({
    model_name: '',
    min_temp: '',
    max_temp: '',
    boost_mode_exists: "",
    series_type: "select",
    low_temperature: [],
  })

  const getModelDetails = () => {
    dispatch(actions.getSingleHeatPumpModel(modelId)).then((res) => {
      if (res?.code == 200) {
        const { boost_mode_exists, max_temp, min_temp, model_name, series_type, low_temperature, } = res?.info

        setModelData({ ...modelData, boost_mode_exists: boost_mode_exists ? true : false, max_temp, min_temp, model_name, series_type, low_temperature })
      }
    })
  }

  useEffect(() => {
    if (modelId) {
      getModelDetails()
    }
  }, [modelId])

  // Group low temperatures by temp value using lodash
  const groupedLowTemps = _.groupBy(modelData?.low_temperature || [], 'temp');

  return (
    <Grid container className="location-container p-0">
      <Grid item xs={12} className="mb-3">
        <Grid container className="location-head con-space-between align-items-center">
          <div className='d-flex align-items-center'>
            <div className="back-btn cursor-pointer" onClick={() => history.goBack()}>
              <ArrowBackIosIcon fontSize="small" />
            </div>
            <Typography variant="h5" component="h3" style={{ marginLeft: 10, fontWeight: 600 }}>
              Model Details
            </Typography>
          </div>
          <div>
            <Button
              variant="contained"
              color="primary"
              className="btn-custom-primary"
              onClick={() => history.push(`/admin/heat_pump/models/update/${modelId}`)}
            >
              Edit Model
            </Button>
          </div>
        </Grid>
      </Grid>

      {isFetchingSingleModel ? (
        <Grid item xs={12} className="d-flex justify-content-center p-5">
          <div className="update-circular-loader">
            <img src="/images/ep-loader.gif" alt="loader" className="loader" />
          </div>
        </Grid>
      ) : (
        <Grid container spacing={2} className="px-1 pt-2">
          <Grid item xs={12} md={6}>
            <Paper className={classes.cardContainer} elevation={0}>
              <Typography className={classes.sectionHeader}>General Information</Typography>

              <Grid container spacing={2} className='mt-2'>
                <Grid item xs={12}>
                  <label className={classes.label}>Model Name</label>
                  <Typography className={classes.value}>{modelData?.model_name || "-"}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Series Type</label>
                  <Typography className={`${classes.value} capitalize`}>{modelData.series_type || "-"}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Boost Mode</label>
                  <Typography className={classes.value}>{modelData.boost_mode_exists ? "Yes" : "No"}</Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper className={classes.cardContainer} elevation={0}>
              <Typography className={classes.sectionHeader}>Temperature Limits</Typography>


              <Grid container spacing={2} className='mt-2'>
                <Grid item xs={6}>
                  <label className={classes.label}>Min Temp</label>
                  <Typography className={classes.value}>{modelData?.min_temp ? `${modelData?.min_temp}\u2103` : "-"}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Max Temp</label>
                  <Typography className={classes.value}>{modelData?.max_temp ? `${modelData?.max_temp}\u2103` : "-"}</Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>


          {modelData?.low_temperature?.length > 0 && (
            <Grid item xs={12}>
              <Paper className={classes.cardContainer} elevation={0}>
                <Typography className={classes.sectionHeader}>Low Temperature (Month Wise)</Typography>


                <Grid container spacing={2} className="mt-4">
                  {Object.entries(groupedLowTemps).map(([temp, items]) => (
                    <Grid item xs={12} sm={6} md={6} lg={6} key={temp} style={{ backgroundColor: '#f8f8f8' }}>
                      <div className={classes.tempGroup}>
                        <div className="d-flex justify-content-between align-items-center mb-2 ">
                          <label className={classes.label} style={{ marginBottom: '0', marginRight: '10px' }}>Temperature</label>
                          <Typography variant="h6" color="primary" style={{ fontWeight: 'bold' }}>
                            {temp.toUpperCase()}°C
                          </Typography>
                        </div>

                        <div>
                          {items.map((m, idx) => (
                            <span key={idx} className={classes.monthTag}>
                              {m.month.toUpperCase()}
                            </span>
                          ))}
                        </div>
                      </div>
                    </Grid>
                  ))}
                </Grid>
              </Paper>
            </Grid>
          )}
        </Grid>
      )}
    </Grid>
  )
}

